export default __webpack_public_path__ + "static/media/star.d0cbd94e.png";